<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                size="small"
                style="width: 180px"
                v-model="queryForm.qstr"
                placeholder="編號、班名、名稱、序號、備註"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            @click="importMember"
            size="small"
            >人員匯入</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addNewMember"
            size="small"
            >新增單位人員</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 單位：{{ myownOrg }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="members"
            @sort-change="sortChange"
            :default-sort="{ prop: 'id', order: 'ascending' }"
            stripe
            style="width: 100%"
          >
            <el-table-column
              prop="id"
              type="index"
              :index="indexFormatter"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="人員編號"
              prop="no"
              sortable="custom"
              width="110"
            >
            </el-table-column>
            <el-table-column
              label="班級名稱"
              prop="className"
              sortable="custom"
              width="110"
            >
            </el-table-column>
            <el-table-column
              label="月光機序號"
              prop="moonlight2SerialNumber"
              sortable="custom"
              width="200"
            >
            </el-table-column>
            <el-table-column
              label="人員名稱"
              prop="name"
              sortable="custom"
              width="110"
            >
            </el-table-column>
            <el-table-column
              label="部門"
              prop="deptMembers"
              :sortable="false"
              width="200"
            >
              <template #default="scope">
                <el-tag v-for="deptMember in scope.row.deptMembers"
                    :key="deptMember.id"
                    :style="getTagStyle(deptMember.dept.color)"
                  >{{ deptMember.dept.name }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="備註"
              prop="memo"
              sortable="custom"
              width="160"
            >
            </el-table-column>

            <el-table-column label="操作">
              <template #default="scope">
                <el-button size="mini" @click="editMember(scope.row.id)"
                  >編輯
                </el-button>
                <el-button
                  type="warning"
                  size="mini"
                  @click="resetMember(scope.row.id)"
                  >重新下載
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteMember(scope.row.id)"
                  >刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>

        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
        <AddEdtMemberDlg
          v-model="isDlgVisible"
          :selectedItemId="dlgItemId"
          :key="dlgKey"
        ></AddEdtMemberDlg>

        <OrgImportMbrDlg
          v-model="isImportDlgVisible"
          :key="`import_${importDlgKey}`"
        ></OrgImportMbrDlg>

      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SYS_ORG_NAME } from "@/appConfig";
import AddEdtMemberDlg from "@/components/org/AddEdtMemberDlg";
import OrgImportMbrDlg from "@/components/org/OrgImportMbrDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  name: "member",
  mixins: [tagColorsMixin],
  components: {
    AddEdtMemberDlg,
    OrgImportMbrDlg,
  },
  created() {
    this.$store.dispatch("member/list", {
      max: this.pageSize,
      offset: this.offset,
      sort: this.sort,
      order: this.order,
    });
  },
  data() {
    return {
      dlgItemId: null,
      dlgKey: 0,
      importDlgKey: 0,
      isDlgVisible: false,
      isImportDlgVisible: false,
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        qstr: "",
      },
    };
  },
  methods: {
    importMember() {
      this.isImportDlgVisible = true;
      this.importDlgKey = this.importDlgKey ? 0 : 1;
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.query(this.pageSize, 0, this.sort, this.order, queryForm);
    },
    addNewMember() {
      this.isDlgVisible = true;
      this.dlgItemId = null;
      this.dlgKey = this.dlgKey ? 0 : 1;
    },
    editMember(id) {
      /*console.log(`editMember: id = ${id}`);*/
      this.dlgItemId = id;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.queryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.queryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      this.$store.dispatch("member/list", {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    resetMember(id) {
      this.$confirm("此操作後將重新下載所有音檔, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("member/reset", id).then(() => {
            this.$message({
              type: "success",
              message: "設定成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    deleteMember(id) {
      this.$confirm("此操作將永久刪除該單位人員, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("member/remove", id).then(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.queryForm
            );
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("member/SET_SORT", "id");
        this.$store.commit("member/SET_ORDER", "ascending");
      } else {
        this.$store.commit("member/SET_SORT", args.prop);
        this.$store.commit("member/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.queryForm
      );
    },
  },
  computed: {
    isMyownOrgSys() {
      return this.myownOrg === SYS_ORG_NAME;
    },
    ...mapGetters({
      myownOrg: "auth/orgName",
      members: "member/members",
      total: "member/total",
      offset: "member/offset",
      sort: "member/sort",
      order: "member/order",
    }),
  },
};
</script>

<style></style>
